module.exports = __webpack_public_path__ + "static/img/header-yj.c4d9550.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my/header-yj.png
// module id = hu8P
// module chunks = 1